import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ArticlesService } from '../services/articles.service';
import { ModalService } from '../shared/modal/modal.service';
import { FormAddArticleComponent } from '../shared/forms/form-add-article/form-add-article.component';
import {ApiObject} from '../services/api-calls.service';
import {EditingService} from '../services/editing.service';
import { AnimatedArticleRightComponent } from '../shared/animated-article-right/animated-article-right.component';
import { AnimatedArticleLeftComponent } from '../shared/animated-article-left/animated-article-left.component';

import { PageTitleComponent } from '../shared/page-title/page-title.component';

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss'],
    imports: [PageTitleComponent, AnimatedArticleLeftComponent, AnimatedArticleRightComponent]
})
export class AboutComponent {
  private articleService = inject(ArticlesService);
  private modal = inject(ModalService);
  private editService = inject(EditingService);
  private destroyRef = inject(DestroyRef);

  readonly editMode = this.editService.editMode;
  /**
   * The articles to be used on the page.
   */
  articles: ApiObject[];

  /**
   * sets the type of article for the page, so that the correct url is used.
   *
   * @type {string}
   */
  type = 'about';

  constructor() {
    this.getArticles();
  }

  /**
   * opens the modal for creating articles on the page
   * This is returned from the after close area of the modal.
   */
  onAddItem() {
    this.modal.open(FormAddArticleComponent, {data: {type: this.type, title: 'Create Article on page' + this.type}})
        .afterClosed.pipe(takeUntilDestroyed(this.destroyRef)).subscribe( response => {
      this.articleService.saveArticles(response);
      this.getArticles();
    });
  }

  /**
   * gets the articles for the french polishing pages
   */
  getArticles() {
    this.articleService.getArticles(this.type).pipe(takeUntilDestroyed(this.destroyRef)).subscribe( data => {
      this.articles = data;
    });
  }
}
